import { render, staticRenderFns } from "./icons-list.html?vue&type=template&id=15e06084&scoped=true&external"
import script from "./icons-list.js?vue&type=script&lang=js&external"
export * from "./icons-list.js?vue&type=script&lang=js&external"
import style0 from "./icons-list.scss?vue&type=style&index=0&id=15e06084&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e06084",
  null
  
)

export default component.exports